import { FC, memo, useMemo } from 'react'
import { Box, BoxProps, Flex, Text, useColorModeValue } from '@chakra-ui/react'

import { CATEGORIES_OBJECT } from 'constants/variables'

type Props = BoxProps & {
  view?: 'default' | 'tableCell'
  category?: string
  customColor?: string
  customBg?: string
}

const Category: FC<Props> = ({ view = 'default', category, customColor, customBg, ...rest }) => {
  const { color, name, Icon } = useMemo(() => {
    if (CATEGORIES_OBJECT[category as string]) return CATEGORIES_OBJECT[category as string]
    return CATEGORIES_OBJECT['UNKNOWN']
  }, [category])

  const defaultColor = useColorModeValue(`${color}.700`, `${color}.100`)
  const defaultBg = useColorModeValue(`${color}.100`, `${color}.700`)
  const textColor = useColorModeValue(`${color}.500`, `${color}.200`)

  if (view === 'tableCell') {
    return (
      <Flex display="flex" alignItems="center" gap={2}>
        <Icon color={textColor} />
        <Text color={textColor}>{name}</Text>
      </Flex>
    )
  }

  return (
    <Box p={2} bg={customBg || defaultBg} rounded="md" {...rest}>
      <Icon boxSize={6} color={customColor || defaultColor} />
    </Box>
  )
}

export default memo(Category)
